var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21C6.34 21 5 22.34 5 24C5 25.66 6.34 27 8 27C9.66 27 11 25.66 11 24C11 22.34 9.66 21 8 21ZM8 9C6.34 9 5 10.34 5 12C5 13.66 6.34 15 8 15C9.66 15 11 13.66 11 12C11 10.34 9.66 9 8 9ZM8 33C6.34 33 5 34.36 5 36C5 37.64 6.36 39 8 39C9.64 39 11 37.64 11 36C11 34.36 9.66 33 8 33ZM14 38H42V34H14V38ZM14 26H42V22H14V26ZM14 10V14H42V10H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.d48725ecab874621269a653739d26d53.svg";
export { ForwardRef as ReactComponent };